export default "__VITE_ASSET__CEMqrBg___"